var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status===10)?_c('el-tag',{attrs:{"type":"primary"}},[_vm._v("新建")]):_vm._e(),(_vm.status===13)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("已发送")]):_vm._e(),(_vm.status===200)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("已结束")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }